import { forwardRef } from "react";

import { SHIPPING_COUNTRIES_QUERY } from "@/graphql/shop";
import sortShippingCountries from "@/utils/sortShippingCountries";
import { useQuery } from "@apollo/client";

import NativeSelect from "./NativeSelect";

const ShippingCountrySelect = forwardRef(
  (
    {
      placeholder,
      onChange,
      value,
      error,
      label,
      name,
      getOptions,
      fontSize,
      valueField,
      fullWidth,
      disabled,
      ...wrapperStyles
    },
    ref
  ) => {
    const { data, loading } = useQuery(SHIPPING_COUNTRIES_QUERY);

    if (loading) {
      return (
        <NativeSelect
          readOnly={disabled}
          name={name}
          ref={ref}
          onChange={onChange}
          value={value}
          error={error}
          label={label}
          fontSize={fontSize}
          styles={{
            select: {
              fontSize: [14, 14, 16]
            },
            wrapper: {
              maxWidth: fullWidth ? null : 350,
              ...wrapperStyles
            }
          }}
        />
      );
    }

    let options;
    if (getOptions) {
      options = getOptions(sortShippingCountries(data?.shippingCountries ?? []));
    } else {
      options = sortShippingCountries(data?.shippingCountries ?? []).map(item => ({
        value: item[valueField],
        label: item.name
      }));
    }

    return (
      <NativeSelect
        readOnly={disabled}
        name={name}
        ref={ref}
        onChange={onChange}
        value={value}
        error={error}
        label={label}
        styles={{
          select: {
            fontSize: [14, 14, 16]
          },
          wrapper: {
            maxWidth: fullWidth ? null : 350,
            ...wrapperStyles
          }
        }}
      >
        <option value="">{placeholder}</option>
        {options?.map((item, idx) => (
          <option key={`${item.value}-${idx}`} value={item.value}>
            {item.label}
          </option>
        ))}
      </NativeSelect>
    );
  }
);

ShippingCountrySelect.defaultProps = {
  placeholder: "Select a country",
  valueField: "name"
};

export default ShippingCountrySelect;
